enum Tdt {
	IXCHANGE2 = 'IXCHANGE2',
	PORTAIL = 'PORTAIL',
}

export default Tdt;
